export const checkboxData = [
  {
    contentsWithTitle: [
      {
        tilte: "البنية التحتية والمرافق",
        contents: [
          "المبنى المدرسي محافظ عليه بشكل جيد",
          "فصول دراسية منفصلة لمستويات الصفوف المختلفة",
          "مكتبة تحتوي على مجموعة متنوعة من الكتب والموارد",
          "مختبرات علوم مجهزة بشكل جيد",
          "مختبرات حاسوب للطلاب",
          "غرفة فنية مخصصة",
          "مرافق رياضية مثل ملعب وصالة رياضية",
          "غرفة موسيقى",
          "حمامات نظيفة وقائمة بشكل جيد",
          "كافتيريا أو منطقة توزيع الوجبات",
          "مناطق جلوس خارجية للطلاب",
          "غرفة مخصصة للصلاة أو التأمل",
        ],
      },

      {
        tilte: "العروض الأكاديمية",
        contents: [
          "تقديم مجموعة واسعة من المواد",
          "توفر دورات متقدمة (AP)",
          "أنشطة أكاديمية خارج الدروس مثل نادي النقاش ونادي الرياضيات",
          "أنشطة أكاديمية خارج الدروس",
          "نادي الواجبات المنزلية أو دروس مساعدة بعد الدراسة",
        ],
      },
      {
        tilte: "الجنس",
        contents: ["ذكر", "أنثى", "كلاهما"],
      },
      {
        tilte: "الموظفين التعليميين",
        contents: [
          "معلمين مؤهلين ومعتمدين",
          "نسبة منخفضة بين الطلاب والمعلمين",
          "برامج تطوير مهني للمعلمين",
          "نظام تقييم للمعلمين متاح",
        ],
      },
      {
        tilte: "دعم الطلاب",
        contents: [
          "مستشار متاح للطلاب",
          "برامج للطلاب ذوي الاحتياجات الخاصة",
          "برنامج التوجيه للطلاب",
          "برنامج دعم الأقران الذي يقوده الطلاب",
        ],
      },
      {
        tilte: "الصحة والسلامة",
        contents: [
          "غرفة طبية مجهزة باللوازم الأساسية",
          "ممرض بدوام كامل في الطاقم",
          "خطة استجابة للطوارئ موجودة",
          "تدابير السلامة من الحرائق في المدرسة",
          "نظام أمني متاح",
        ],
      },
      {
        tilte: "الأنشطة اللاصفية",
        contents: [
          "فرق رياضية متاحة",
          "أندية فنية وموسيقية متاحة",
          "برنامج دراما أو مسرح",
          "صحيفة طلابية أو نادي صحافة",
          "معارض علوم أو معارض علمية مستضافة",
          "نادي برمجة أو روبوتيات",
        ],
      },
      {
        tilte: "مشاركة المجتمع",
        contents: [
          "التفاعل مع المجتمع المحلي",
          "المشاركة في مشاريع خدمة المجتمع",
          "تشجيع الآباء على المشاركة",
          "تنظيم فعاليات مفتوحة",
        ],
      },
      {
        tilte: "التكنولوجيا والموارد",
        contents: [
          "وصول إلى الواي فاي للطلاب",
          "لوحات تفاعلية في الفصول الدراسية",
          "توفير أجهزة الكمبيوتر المحمولة أو الأجهزة اللوحية للطلاب",
          "موقع الإنترنت المدرسي للتواصل",
          "الموارد عبر الإنترنت المتاحة للطلاب",
        ],
      },
      {
        tilte: "النقل",
        contents: [
          "خدمات الحافلات المدرسية المقدمة من المدرسة",
          "منطقة مخصصة لإنزال واصطفاف الطلاب",
          "تدابير السلامة للنقل",
        ],
      },
      {
        tilte: "برامج خاصة",
        contents: [
          "برنامج للطلاب الموهوبين والمتميزين",
          "برنامج غمرة اللغة",
          "برامج تبادل دولية",
          "برنامج الإرشاد المهني",
          "برنامج الروبوتيات",
        ],
      },
      {
        tilte: "مشاركة الأهل",
        contents: [
          "اجتماعات منتظمة بين الأهل والمعلمين",
          "جمعية أولياء الأمور المدرسية متاحة",
          "مشاركة الآباء في عمليات اتخاذ القرار",
          "برنامج تثقيف الآباء",
        ],
      },
      {
        tilte: "سلوك الطلاب و الانضباط",
        contents: [
          "ميثاق واضح للسلوك",
          "سياسة مكافحة التنمر موجودة",
          "عقوبات للسلوك التخريبي",
          "برنامج وساطة الأقران",
        ],
      },
      {
        tilte: "الاستعداد للحياة المهنية",
        contents: [
          "خدمات الإرشاد المهني متاحة",
          "تقديم برامج تدريب أو برامج دراسة العمل",
          "تنظيم معارض و وظائف",
          "تركيز على تعليم ريادة الأعمال",
        ],
      },
      {
        tilte: "التواصل مع الأهل",
        contents: [
          "توفير تحديثات منتظمة للأهل",
          "النشرة المدرسية متاحة",
          "أنظمة الاتصال الآلي مثل البريد الإلكتروني والرسائل القصيرة قيد الاستخدام",
          "بوابة الأهل للوصول عبر الإنترنت",
        ],
      },
    ],
    contentsNoTitle: ["التعليم الابتكاري", "تضمين التعلم المستمر"],
  },
];
export const checkboxDataEn = [
  {
    contentsWithTitle: [
      {
        tilte: "Infrastructure and Facilities",
        contents: [
          "School edifice is well maintained.",
          "Separate classrooms for various academic tiers.",
          "A library that contains various valuable books",
          "Modern laboratories equipped with the latest tools and equipment.",
          "Computer Labs for students.",
          "Equipped art room",
          "Numerous sports facilities for students' use.",
          "Music Room/Classroom",
          "Well-kept and Clean Bathrooms.",
          "A cafeteria that provides healthy and nutritiousfood",
          "Outdoor seating areas for students.",
          "Prayer and meditation room.",
        ],
      },

      {
        tilte: "Academic Offers",
        contents: [
          "Offering a wide range of subjects.",
          "Offering AP (Advanced Placement) programs.",
          "Special Education Program.",
          "Academic activities outside of lessons.",
          "Homework Club or After-School Tutoring Lessons",
        ],
      },
      {
        tilte: "Gender",
        contents: ["Males", "Females", "Both"],
      },
      {
        tilte: "Educational Staff",
        contents: [
          "Qualified and Certified Teachers",
          "Low ratio between students and teachers",
          "Standard development programs for teachers",
          "Teacher evaluation system available",
        ],
      },
      {
        tilte: "Student Support",
        contents: [
          "Counsellor available for students",
          "Programs for students with special needs.",
          "Student Guidance Program",
          "Student-led Peer Support Program.",
        ],
      },
      {
        tilte: "Health and Safety",
        contents: [
          "Medical room equipped with essential supplies.",
          "Full-time nurse on staff",
          "Emergency response plan in place",
          "Fire safety measures in the school.",
          "Security system available",
        ],
      },
      {
        tilte: "Extracurricular activities",
        contents: [
          "Sports teams available",
          "Art and music clubs available.",
          "Drama or theatre program",
          "Student newspaper or journalism club",
          "Science fairs or hosted scientific exhibitions.",
          "Coding or robotics club.",
        ],
      },
      {
        tilte: "Community engagement",
        contents: [
          "Interaction with the local community.",
          "Participation in community service projects",
          "Encouraging parental involvement.",
          "Organizing open events.",
        ],
      },
      {
        tilte: "Technology and Resources",
        contents: [
          "Wi-Fi access for students",
          "Interactive boards in classrooms",
          "Provision of laptops or tablets",
          "Educational website for communication",
          "Online resources available to students",
        ],
      },
      {
        tilte: "Transportation",
        contents: [
          "School bus services provided by the school.",
          "Designated area for student drop-off and parking.",
          "Safety measures for transportation.",
        ],
      },
      {
        tilte: "Special Programs",
        contents: [
          "Program for gifted and talented students.",
          "Language immersion program.",
          "International exchange programs.",
          "Career guidance program.",
          "Robotics program.",
        ],
      },
      {
        tilte: "Parental Involvement",
        contents: [
          "Regular meetings between parents and teachers",
          "School parent association available",
          "Parental participation in decision-making processes.",
          "Parent education program",
        ],
      },
      {
        tilte: "Student Behaviour and Discipline",
        contents: [
          "A clear behaviour charter.",
          "Anti-bullying policy in place",
          "Penalties for destructive behaviour",
          "Peer mediation program",
        ],
      },
      {
        tilte: "Career Readiness",
        contents: [
          "Career counselling services available.",
          "Offering training programs or work-study programs.",
          "Organizing job fairs and careers events.",
          "Focus on entrepreneurship education",
        ],
      },
      {
        tilte: "Communication with Parents",
        contents: [
          "Providing regular updates to parents.",
          "School newsletter available",
          "Use of automated communication systemslike email and text messaging.",
          "Parent portal for online access.",
        ],
      },
    ],
    contentsNoTitle: ["Innovative Education", "Include constant learning"],
  },
];
export const currencies = [
  {
    id: "SAR",
    currency: "ريال سعودي",
    currencyEn: "Riyal",
  },
  {
    id: "USD",
    currency: "دولار أمريكي",
    currencyEn: "Dolar",
  },
];
